import React from 'react'
import PropTypes from 'prop-types'
import Headline from '../../a/Headline'
import Text from '../../a/Text'
import Avatar from '../../a/Avatar'
import HorizontalRule from '../../a/HorizontalRule'
import SearchResultNavigationButtons from './SearchResultNavigationButtons'

export function SearchResultEntry({azubi, onNavigationButtonClick}) {
  const {firstname, lastname, profileImage, markt} = azubi
  return (
    <div className="searchResultEntry">
      <div className="userInfo">
        <Avatar profileImage={profileImage} />
        <Headline importance={2} modifier="fragment" text={`${lastname}, ${firstname}`} />
        <Text modifier="extrasmall" text={markt} />
      </div>
      <SearchResultNavigationButtons azubi={azubi} onNavigationButtonClick={() => onNavigationButtonClick()} />
      <HorizontalRule />
    </div>
  )
}

SearchResultEntry.propTypes = {
  azubi: PropTypes.object,
  onNavigationButtonClick: PropTypes.func,
}

export default SearchResultEntry
